import { Base } from '@studiometa/js-toolkit';
import Select from '../Select.js';

/**
 * StickyBar
 */
export default class ProductStickyBar extends Base {
  isVisible = false;
  breakpoints = ['xxs', 'xs', 's'];
  quantity = 1;

  static config = {
    name: 'ProductStickyBar',
    components: {
      QuantitySelect: Select,
    },
    refs: ['mainPrice', 'mainPriceWrapper', 'defaultPrice', 'salePrice'],
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @returns {void}
   */
  scrolled() {
    const position = this.addToCartPosition;

    if (position < 50 && !this.isVisible && !this.isMobile) {
      this.$el.classList.remove('s:-translate-y-full');
      this.isVisible = true;
      return;
    }

    if (this.isVisible && position >= 50 && !this.isMobile) {
      this.isVisible = false;
      this.$el.classList.add('s:-translate-y-full');
    }
  }

  /**
   * Update prices when adding upsell products
   * @param {*} additionnalPrices price to add
   * @param {*} totalPrice final price
   */
  updatePrices(additionnalPrices, totalPrice) {
    if (additionnalPrices > 0) {
      this.$refs.mainPrice.innerHTML = Number.parseFloat(totalPrice).toFixed(2).replace('.', ',');
      this.$refs.mainPriceWrapper.classList.remove('hidden');
    } else {
      this.$refs.mainPriceWrapper.classList.add('hidden');
    }
  }

  /**
   * Update prices when quantity changed
   * @param {string} defaultPrice
   * @param {string} defaultSalePrice
   */
  updatePriceBasedOnQuantity(defaultPrice, defaultSalePrice) {
    this.$refs.defaultPrice.innerHTML = defaultPrice;
    if (this.$refs.salePrice) {
      this.$refs.salePrice.innerHTML = defaultSalePrice;
    }
  }

  /**
   *
   * @param {*} param0
   */
  onQuantitySelectClickItem({ args }) {
    const [index] = args;

    this.$parent.updateAllQuantities(index, this.$config.name);
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * Get Main Add To Cart position
   * @returns {number}
   */
  get addToCartPosition() {
    return this.$parent.$refs.addToCart.getBoundingClientRect().top;
  }
}
